import { useContext } from 'react'

import utils from '../../utils/utils'
import SchedaCopiataContext from './context'

const useSchedaCopiata = () => {
  const { schedaCopiata, setSchedaCopiata } = useContext(SchedaCopiataContext)

  const popolaSchedaCopiata = (value) => {
    if (!value) {
      setSchedaCopiata(undefined)
      return
    }
    setSchedaCopiata({
      ...value,
      values: value.values ? utils.preparaValoriPerCopia(value.values) : value.values,
    })
  }

  return {
    schedaCopiata,
    popolaSchedaCopiata,
  }
}

export default useSchedaCopiata
